import { Modal, Form, IFormContext } from 'rewire-ui';
import { OccupationInsertInput }     from '../DataTypes';
import DataMutations                 from '../graphql/Mutations';
import { notifications }             from '../ui/Notifications';

export class AddOccupationDialogModel extends Modal {
  form: Form;

  constructor() {
    super('Add Occupation');
    this.form = Form.create((form: IFormContext) => ({
      name: form.string().label('Occupation Name').validators('required').placeholder('enter occupation name').autoFocus(),
      code: form.string().label('Code').placeholder('enter occupation code'),
    }));
    this.action('cancel')
        .action('save', this.submit, { variant: 'contained', type: 'submit'});
  }

  reset() {
    this.form.reset();
  }

  load() {
    this.reset();
    this.open();
  }

  private save = async (): Promise<boolean> => {
    const occupationInput: OccupationInsertInput = {
      name: this.form.field.name.value,
      code: this.form.field.code.value,
    };
    const result = await DataMutations.insertOccupations('', [occupationInput]);

    if (result && result[0]) {
      notifications.success('Occupation Created');
      return true;
    }

    notifications.error('Occupation Creation Failed');
    return false;
  };

  submit = async () => {
    return await this.form.submitAsync(this.save);
  };
}

const addOccupationDialogModel = new AddOccupationDialogModel();
export default addOccupationDialogModel;
